import { render, staticRenderFns } from "./JsonFormInput.vue?vue&type=template&id=19bf400b&"
import script from "./JsonFormInput.vue?vue&type=script&lang=js&"
export * from "./JsonFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports